var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-3cy68l",
    "aria-label": "newspaper",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 21V21C20.105 21 21 20.105 21 19V13C21 12.448 20.552 12 20 12H17V19C17 20.105 17.895 21 19 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H13 M7 11.87H13 M7 16.06H10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12V5C17 4.448 16.552 4 16 4H4C3.448 4 3 4.448 3 5V19C3 20.105 3.895 21 5 21H19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.05df135fd3113b6e0dd3e8b3ab6cb15e.svg";
export { ForwardRef as ReactComponent };